// @Version 1.0.4
export const APPLICATION = 'shared';
export const DEFAULT_PROJECT_APPLICATION = 'project';


export enum CSVKEYS {
   TYPOGRAPHY = 'typography_common-csv',
   COLORS = 'colors_common-csv'
}

export enum FORMERROR {
   required = "required",
   pattern = "pattern",
   maxlength = "maxlength",
   minlength = "minlength",
   number = "number",
   min = "min",
   date = "date",
   different = "different",
   noInsurance = "noInsurance",
   iban = "iban",
   noFondsValue = "noFondsValue",
   pieces = "pieces",
   notAllowed = "notAllowed",
   matDatepickerParse = "matDatepickerParse",
   invalid = "invalid",
   pos = "pos" 
}

export enum SESSIONSTORAGE {
   API_KEY = 'apiKey',
   ACCESSTOKEN = 'accesstoken'
}

export enum BREAKPOINTS {
   MOBILE = '(max-width: 575px)',
   TABLET = '(min-width: 576px)',
   DESKTOP = '(min-width: 1499px)'
}

export enum VIEWPORTCLASS {
   MOBILE = 'mobile',
   TABLET = 'tablet',
   DESKTOP = 'desktop'
}

export enum FIELD_APPEARANCE {
   FILLED = 'fill',
   OUTLINED = 'outline',
   NO_FLOATING_LABEL = 'always'
}

export enum DESIGN_DEFAULT {
   FIELDMODE_SQUARE = 'square',
   CLASS_FIELDMODE_SQUARE = 'square-design',
}

export enum CONFIG_HEADER {
   HEADER_SHADOW_ENABLED = 0,
   HEADER_SHADOW_VARIANT,
   HEADER_BURGER_ENABLED
}

export enum CONFIG_FOOTER {
   FOOTER_SHADOW_ENABLED = 0,
   FOOTER_SHADOW_VARIANT,
   FOOTER_NAVIGATION_ENABLED,
   FOOTER_BURGER_ENABLED
}

export enum SHADOW_VARIANT {
   DEFAULT = '1'
}

export enum FIXED_VARIANT {
   DEFAULT = '1'
}

export enum DATE {
   INVALID = "Invalid date",
   FORMAT_DE = "DD.MM.YYYY",
   FORMAT_DE_PIPE = "dd.MM.YYYY",
   FORMAT_EN = "YYYY-MM-DD"
}


export enum BANKLOGO_POS {
   LEFT = 0,
   RIGHT
}

enum TRANSLATE_PATH_BASIC {
   HEADER_LOGO_LINK = 'shared.components.header.logo.link',
   HEADER_LOGO_SRC = 'shared.components.header.logo.src',
   HEADER_LOGO_POS = 'shared.components.header.logo.pos',
   HEADER_LOGO_HEIGHT = "shared.components.header.logo.height",
   HEADER_LOGO_ALT = 'shared.components.header.logo.alt',
   HEADER_LOGOMOBILE_SRC = 'shared.components.header.logo-mobile.src',
   HEADER_LOGOMOBILE_ENABLED = 'shared.components.header.logo-mobile.enabled',
   HEADER_LOGOMOBILE_HEIGHT = "shared.components.header.logo-mobile.height",
   HEADER_ACTION_LOGO_ENABLED = 'shared.components.header.action-logo.enabled',
   HEADER_ACTION_LOGO_LINK = 'shared.components.header.action-logo.link',
   HEADER_ACTION_LOGO_SRC = 'shared.components.header.action-logo.src',
   HEADER_ACTION_LOGO_ALT = 'shared.components.header.action-logo.alt',
   HEADER_ACTION_LOGO_HEIGHT = "shared.components.header.action-logo.height",
   HEADER_MENU_ALT = 'shared.components.header.menu.alt',
   HEADER_MENU_ICON = 'shared.components.header.menu.icon',
   HEADER_BOTTOM_ENABLED = 'shared.components.header.bottom.enabled',
   HEADER_SHADOW_ENABLED = 'shared.components.header.withShadow',
   HEADER_SHADOW_VARIANT = 'shared.components.header.shadow.variant',
   HEADER_BURGER_ENABLED = 'shared.components.header.withBurger',
   HEADER_FIXED_VARIANT = 'shared.components.header.fixed',

   SPINNER_PATH = 'shared.components.spinner.',
   SPINNER_ICON = 'icon',
   SPINNER_COLOR = 'color',
   SPINNER_TITLE = 'title',
   SPINNER_MESSAGE = 'message',

   MAINTENANCE_WORK_ERROR_PREFIX = "shared.pages.maintenance-work.error-prefix",
   MAINTENANCE_WORK_TITLE = "shared.pages.maintenance-work.title", 
   MAINTENANCE_WORK_ICON_COLOR = "shared.pages.maintenance-work.icon.color", 
   MAINTENANCE_WORK_ICON_TYPE = "shared.pages.maintenance-work.icon.type", 
   MAINTENANCE_WORK_DESCRIPTION_COLOR = "shared.pages.maintenance-work.description.color",
   MAINTENANCE_WORK_DESCRIPTION_SORRY = "shared.pages.maintenance-work.description.sorry", 
   MAINTENANCE_WORK_DESCRIPTION_TEXT = "shared.pages.maintenance-work.description.text",
  
   NOTFOUND_TITLE = "shared.pages.not-found.title", 
   NOTFOUND_ICON_COLOR = "shared.pages.not-found.icon.color", 
   NOTFOUND_ICON_TYPE = "shared.pages.not-found.icon.type",
   NOTFOUND_DESCRIPTION_COLOR = "shared.pages.not-found.description.color", 
   NOTFOUND_DESCRIPTION_SORRY = "shared.pages.not-found.description.sorry",
   NOTFOUND_DESCRIPTION_TEXT = "shared.pages.not-found.description.text",
   
   BANKNAME = 'shared.bankname',
   FIELDMODE = 'shared.design.field_mode',
   DESIGN_MODE = "shared.design.mode",

   FOOTER_COPYRIGHT = 'shared.components.footer.copyright',
   FOOTER_LIST = 'shared.components.footer.list',
   FOOTER_LIST_URL = 'url',
   FOOTER_LIST_NAME = 'name',
   FOOTER_LIST_SEP = 'shared.components.footer.separator',
   FOOTER_FIXED_VARIANT = 'shared.components.footer.fixed.variant',
   
   FOOTER_SHADOW_ENABLED = 'shared.components.footer.withShadow',
   FOOTER_SHADOW_VARIANT = 'shared.components.footer.shadow.variant',
   
   FOOTER_TOP_ENABLED = 'shared.components.footer.top.enabled',
   FOOTER_TOP_TEXT = 'shared.components.footer.top.text',
   
   FOOTER_BOTTOM_ENABLED = 'shared.components.footer.bottom.enabled',
   FOOTER_BOTTOM_COLOR = 'shared.components.footer.bottom.color',
   FOOTER_BOTTOM_ENABLED_TEXT = 'shared.components.footer.bottom.enabled-text',
   FOOTER_BOTTOM_TEXT = 'shared.components.footer.bottom.text-slogan',
   
   FOOTER_CHANGE_COLOR = 'shared.components.footer.mobile.change-color',

   BLANK_NOMOBILE_ENABLED = "shared.components.blank.no-mobile.enabled",
   BLANK_NOMOBILE_AS_PAGE = "shared.components.blank.no-mobile.asPage",

   NO_MOBILE = "shared.pages.no-mobile.",
   NO_MOBILE_ICON_COLOR = "icon.color",
   NO_MOBILE_ICON_TYPE = "icon.type",
   NO_MOBILE_TITLE = "title",
   NO_MOBILE_MESSAGE = "message",
  
   FRAME_SHOW = "shared.components.frame.show",
   IFRAME_SIZE = "shared.design.basic.iframe.size"
}

enum TRANSLATE_PATH_NAVLIST {
   NAV_LIST_DEFAULT_LIST = "shared.components.nav-list.list.default"
}

export enum TRANSLATE_PATH_FIELDS {
    REQUIRED = "shared.required",  

   //TODO NAmen anpassen
   FIELD_ITEM_ERROR = "shared.components.field-item.error",

   // Field Items
   FIELD_ITEMS = "shared.components.field-item",

   FIELD_ITEMS_LINK_BUTTON = ".link-button",
   FIELD_ITEMS_DOWNLOAD_LINK = ".download-link",
   FIELD_ITEMS_TOGGLE = ".toggle",

   DEFAULT_COLOR = ".default-color", 
   SUCCESS_COLOR = ".success-color",
   DEFAULT_ICON = ".default-icon",
   SUCCESS_ICON = ".success-icon",

   FIELD_ITEMS_REQUIRED = ".required",
   FIELD_ITEMS_VALID = ".valid",
   FIELD_ITEMS_DESCRIPTION = ".description",
   FIELD_ITEMS_FIELDTYPE = ".fieldtype",
   FIELD_ITEMS_ATTRIBUTE_1 = ".attribute_1",
   FIELD_ITEMS_ATTRIBUTE_2 = ".attribute_2",
   FIELD_ITEMS_ATTRIBUTE_3 = ".attribute_3",
   FIELD_ITEMS_ATTRIBUTE_4 = ".attribute_4",
   FIELD_ITEMS_ATTRIBUTE_5 = ".attribute_5",
   FIELD_ITEMS_LABEL = "label",

   // Button Fileupload
   FIELD_ITEMS_FILEUPLOAD = "shared.components.field-item.fileupload-button",
   DIALOG_FILEUPLOAD = "shared.dialogs.fileupload",
   
   DIALOG_FILEUPLOAD_BUTTON_SAVE = ".buttons.save",
   DIALOG_FILEUPLOAD_BUTTON_CANCEL = ".buttons.cancel",
   DIALOG_FILEUPLOAD_BUTTON_DELETE = ".buttons.delete",
   

   // field Item Buttons
   DOWNLOAD_DONE = "shared.components.field-item.download-button.text",
   LINK_DONE = "shared.components.field-item.link-button.text",
   FILEUPLOAD_DONE = "shared.components.field-item.fileupload-button.text"
}

export enum TRANLSATE_PATH_FILEUPLOAD {
   FILEUPLOAD_MAXFILESIZE = ".maxFileSize",
   FILEUPLOAD_MAXNUMBEROFFILES = ".maxNumberOfFiles",
   FILEUPLOAD_ALLOWEDEXTENSIONS = ".allowedExtensions",
   FILEUPLOAD_SHOW_ICON_COLOR = ".showIconColor",
   FILEUPLOAD_SHOW_ICON = ".showIcon",
   FILEUPLOAD_REMOVE_ICON_COLOR = ".removeIconColor",
   FILEUPLOAD_REMOVE_ICON = ".removeIcon",
   FILEUPLOAD_SIZE_SUFFIX = ".size",
}

enum TRANSLATE_PATH_DESIGN {
   BUTTONMODE = 'shared.design.mode',
   COLOR_BUTTON_COMMON = "shared.design.color.button.common",
   COLOR_REDIRECT = 'shared.design.color.button.redirect',
   COLOR_TITLE = 'shared.design.color.title',
   COLOR_ICON = "shared.design.color.icon",
   COLOR_CHECKBOX = "shared.design.color.checkbox.common",
   COLOR_CHECKBOX_IMPORTANT = "shared.design.color.checkbox.important",
   COLOR_TOGGLE = "shared.design.color.button.toggle",
   COLOR_RADIO = "shared.design.color.radio",
   COLOR_RATING = "shared.design.color.rating"
}



export const TRANSLATE_PATH = {
   ...TRANSLATE_PATH_BASIC, 
   ...TRANSLATE_PATH_DESIGN,
   ...TRANSLATE_PATH_FIELDS,
   ...TRANLSATE_PATH_FILEUPLOAD,
   ...TRANSLATE_PATH_NAVLIST
}